export default __webpack_public_path__ + "static/media/1.7c42a754.jpg";